"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsxs)("g", {
      fill: "currentColor",
      fillRule: "nonzero",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M20.19 16.362a4.867 4.867 0 00-4.876 4.876c0 2.7 2.176 4.876 4.876 4.876s4.877-2.176 4.877-4.876-2.177-4.876-4.877-4.876z"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M29.943 12.686H27.58a2.43 2.43 0 01-2.024-1.086l-.976-1.505a2.424 2.424 0 00-2.024-1.085h-4.724a2.43 2.43 0 00-2.023 1.085l-.977 1.5a2.424 2.424 0 01-2.023 1.086h-2.372A2.438 2.438 0 008 15.124v13.428a2.43 2.43 0 002.438 2.438h19.505a2.43 2.43 0 002.438-2.438V15.124a2.43 2.43 0 00-2.438-2.438zM20.19 28.552a7.298 7.298 0 01-7.314-7.314 7.298 7.298 0 017.314-7.314 7.298 7.298 0 017.315 7.314c0 4.014-3.262 7.314-7.315 7.314z"
      })]
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Camera.js.map